import { useState } from "react";
import { useNavigate } from 'react-router-dom'
import Button from '@/components/ui/Button'
import { ThumbsUp, ThumbsUpIcon, Heart, HeartIcon } from "lucide-react";
import { FaRegThumbsUp, FaThumbsUp } from "react-icons/fa";

function BirthdayAnniversaryWishes() {
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);
  const [thanked, setThanked] = useState(false);
  return (
    <div className='page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8 plain-top-bar-page'>
      <style>
        {`
          .breadcrumb a {
            color: rgb(132, 90, 223);
          }
          .breadcrumb-item.active {
            position: relative;
            padding-left: 7px;
            display: flex;
          }
          .breadcrumb-item.active::before {
            display: block;
            content: "❯❯";
            font-weight: bold;
            letter-spacing: -1px;
            padding-right: 7px;
            font-size: 10px;
            position: relative;
            top: 4px;
          }
          .plain-top-bar-page .page-header-breadcrumb {
            width: calc(100% - 64px);
          }
        `}
      </style>
      <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between mb-4 page-header-breadcrumb">
        <h5 className="mb-0">Birthday / Anniversary Wishes</h5>
        <div className="ms-md-1 ms-0">
          <nav>
            <ol className="breadcrumb flex mb-0">
              <li className="breadcrumb-item">
                <a className='cursor-pointer' onClick={() => navigate("/dashboard/hrdashboard?mc=6004")}>Home</a>
              </li>
              <li aria-current="page" className="breadcrumb-item active">
                Birthday / Anniversary Wishes
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div className='card p-5 px-8'>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-[30px] mb-3">
          <div className='relative custom-card-shadow rounded-lg bday-wish bday-wish-bg'>
            {/* bg-gradient-to-l from-slate-300 to-slate-100 */}
            <h3 className='ribbon'>Best Wishes</h3>
            <div className="content p-5 px-8">
              <div className='flex items-center gap-4'>
                  <div className="profile-pic">
                    <img className="img-fluid rounded-xl w-[80px] h-[80px] min-w-[80px] min-h-[80px] custom-card-shadow" alt="user image" src="/portal/img/others/default-men.png" />
                  </div>
                  <div className="profile-info">
                    <h4>Arul</h4>
                    <p>Senior Designer</p>
                    <p className='inline-block font-semibold bg-purple-200 text-purple-600 text-[10px] px-2 py-1 mt-2 rounded'>IT Department</p>
                  </div>
              </div>
              <div className='celebration-content flex items-center gap-4 mt-3'>
                <img className="img-fluid w-[80px] h-[80px] min-w-[80px] min-h-[80px]" alt="cake image" src="/portal/img/others/cake.png" />
                <div>
                  <h5>Happy Birthday</h5>
                  <p>Tomorrow, Sept 11</p>
                </div>
              </div>
              <div>
                <p className='bg-white text-black my-1 p-2 rounded'>&#128150; 8 wishes posted</p>
                <h6 className='text-[14px] my-1'>Recent Wishes:</h6>
                <div className="flex flex-col mb-2">
                  <div className='recent-wish'>
                    <span className="sender">Sarah M:</span>
                    "Happy Birthday! Hope your day is amazing! 🎉"
                  </div>
                  {/* like and thanks Actions */}
                  <div className="flex justify-end gap-1">
                    {/* <button
                      onClick={() => setLiked(!liked)}
                      className="p-1 hover:scale-110 transition"
                    >
                      {liked ? (
                        <FaThumbsUp className="w-4 h-4 text-blue-600 fill-green-600" />
                      ) : (
                        <FaRegThumbsUp className="w-4 h-4 text-gray-500" />
                      )}
                    </button> */}

                    <button
                      onClick={() => setLiked(!liked)}
                      className="p-1 hover:scale-110 transition"
                    >
                      {liked ? (
                        <Heart className="w-4 h-4 text-red-600 fill-red-600" />
                      ) : (
                        <Heart className="w-4 h-4 text-gray-500" />
                      )}
                    </button>
                    {/* Thanks 🙏 */}
                    <button
                      onClick={() => setThanked(!thanked)}
                      className="p-1 hover:scale-110 transition text-xl"
                    >
                      <span
                        className={
                          thanked
                            ? "text-yellow-500 drop-shadow-sm"
                            : "text-gray-500 opacity-70"
                        }
                      >
                        🙏
                      </span>
                    </button>
                  </div>
                </div>
                <div className="recent-wish">
                  <span className="sender">Mike R:</span>
                  "Wishing you all the best on your special day!"
                </div>
              </div>
              <div>
                <Button
                  className='bg-purple text-white px-3 hover:bg-purple hover:text-white hover:ring-0 hover:border-transparent flex items-center gap-2'
                >
                  🎁 Send Wishes
                </Button>
              </div>
            </div>
          </div>
          <div className='relative custom-card-shadow rounded-lg bday-wish bday-wish-bg'>
            {/* bg-gradient-to-l from-slate-300 to-slate-100 */}
            <h3 className='ribbon'>Best Wishes</h3>
            <div className="content p-5">
              <div className='flex items-center gap-4'>
                  <div className="profile-pic">
                    <img className="img-fluid rounded-xl w-[80px] h-[80px] min-w-[80px] min-h-[80px] custom-card-shadow" alt="user image" src="/portal/img/others/default-men.png" />
                  </div>
                  <div className="profile-info">
                    <h4>Selvaraj</h4>
                    <p>Senior Developer</p>
                    <p className='inline-block font-semibold bg-purple-200 text-purple-600 text-[10px] px-2 py-1 mt-2 rounded'>IT Department</p>
                  </div>
              </div>
              <div className='celebration-content anniversary-content flex items-center gap-4 mt-3'>
                <img className="img-fluid w-[80px] h-[80px] min-w-[80px] min-h-[80px]" alt="wedding image" src="/portal/img/others/wedding.png" />
                <div>
                  <h5>Wedding Anniversary</h5>
                  <p>Today, Sept 10</p>
                </div>
              </div>
              <div>
                <p className='bg-white text-black my-2 p-2 rounded'>&#128150; 8 wishes posted</p>
                <h6 className='text-[14px] my-2'>Recent Wishes:</h6>
                <div className='recent-wish'>
                  <span className="sender">Sarah M:</span>
                  "Happy Birthday! Hope your day is amazing! 🎉"
                </div>
                <div className="recent-wish">
                  <span className="sender">Mike R:</span>
                  "Wishing you all the best on your special day!"
                </div>
              </div>
            </div>
          </div>
          <div className='relative custom-card-shadow rounded-lg bday-wish bday-wish-bg'>
            {/* bg-gradient-to-l from-slate-300 to-slate-100 */}
            <h3 className='ribbon'>Best Wishes</h3>
            <div className="content p-5">
              <div className='flex items-center gap-4'>
                  <div className="profile-pic">
                    <img className="img-fluid rounded-xl w-[80px] h-[80px] min-w-[80px] min-h-[80px] custom-card-shadow" alt="user image" src="/portal/img/others/default-men.png" />
                  </div>
                  <div className="profile-info">
                    <h4>Selvaraj</h4>
                    <p>Senior Developer</p>
                    <p className='inline-block font-semibold bg-purple-200 text-purple-600 text-[10px] px-2 py-1 mt-2 rounded'>IT Department</p>
                  </div>
              </div>
              <div className='celebration-content anniversary-content flex items-center gap-4 mt-3'>
                <img className="img-fluid w-[80px] h-[80px] min-w-[80px] min-h-[80px]" alt="wedding image" src="/portal/img/others/wedding.png" />
                <div>
                  <h5>Wedding Anniversary</h5>
                  <p>Today, Sept 10</p>
                </div>
              </div>
              <div>
                <p className='bg-white text-black my-2 p-2 rounded'>&#128150; 8 wishes posted</p>
                <h6 className='text-[14px] my-2'>Recent Wishes:</h6>
                <div className='recent-wish'>
                  <span className="sender">Sarah M:</span>
                  "Happy Birthday! Hope your day is amazing! 🎉"
                </div>
                <div className="recent-wish">
                  <span className="sender">Mike R:</span>
                  "Wishing you all the best on your special day!"
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BirthdayAnniversaryWishes